import { useEffect, useState } from 'react';

export default function IndefiniteLoadingBar({ className }: { className?: string }) {
    const [position, setPosition] = useState(0);

    useEffect(() => {
        const animateLoader = () => {
            setPosition(prevPosition => {
                // When position reaches 100%, reset to -20% (off-screen to the left)
                // This creates the illusion of continuous movement
                return prevPosition >= 100 ? -20 : prevPosition + 0.5;
            });
        };

        const intervalId = setInterval(animateLoader, 10);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className={`w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-6 relative ${className}`}>
            <div
                className="h-full bg-blue-500 rounded-full absolute"
                style={{
                    width: '20%',
                    left: `${position}%`,
                    transition: 'left 0.01s linear'
                }}
            ></div>
        </div>
    );
}